import React from 'react';
import { ResponsiveContainer } from 'recharts';

import Modal from 'components/Modal';

class DashboardWidget16 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
  }

  show = e => {
    e.preventDefault();
    this.setState({ show: true });
  };

  close = () => {
    this.setState({ show: false });
  };

  render() {
    const { title, chart, bgClass, chartHeight, details } = this.props;
    const { show } = this.state;

    return (
      <div className={'widget-16 card no-border no-margin ' + bgClass}>
        <div className="card-header text-black">
          <div className="card-title">{title}</div>
          {!!details && (
            <div className="pull-right">
              <a href="#details" onClick={this.show} className="text-master">
                <i className="fal fa-info-circle" />
              </a>
            </div>
          )}
        </div>
        <div className="relative no-overflow">
          <div>
            <ResponsiveContainer height={chartHeight}>{chart}</ResponsiveContainer>
          </div>
        </div>

        <Modal show={show} onHide={this.close} bsSize="lg" className="full-width">
          <Modal.Header closeButton>
            <Modal.Title>Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>{details}</Modal.Body>
        </Modal>
      </div>
    );
  }
}
DashboardWidget16.defaultProps = {
  title: null,
  bgClass: 'bg-success',
  chart: null,
  chartHeight: 262,
};

export default DashboardWidget16;
